import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import TextInput from "@builder/components/general/TextInput";
import Toggle from "@builder/components/general/Toggle";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { DropdownNode } from "@common/build/types";

const EditTaxConfigurations = ({ parent }: EditableProps) => {
    const dispatch = useAppDispatch();
    const dNode = useAppSelector(getSelectedNode) as DropdownNode;

    const placeholder = dNode.input?.label;
    const setPlaceholder = (value: string) => {
        dispatch(updateNodeProperty({ propertyPath: ["input", "label"], value }));
    };

    // Adding property to control dropdown open state
    const isDropdownOpen = !!dNode.previewOptions || false; //slightly lazy to do this way but it works
    const setDropdownOpen = () => {
        dispatch(updateNodeProperty({ propertyPath: ["previewOptions"], value: {
            "tax-1": "Tax 1",
            "tax-2": "Tax 2",
            "tax-3": "Tax 3"
        }, remove: isDropdownOpen }));
    };

    return (
        <SidebarCollapse title="Dropdown" parent={parent}>
            <TextInput title="Placeholder" value={placeholder} callback={setPlaceholder} />
            <Toggle label="Show dropdown open" checked={isDropdownOpen} callback={setDropdownOpen} />
        </SidebarCollapse>
    );
};

export default EditTaxConfigurations;
